import script from "./BodySubDivider.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubDivider.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodySubDivider.vue?vue&type=style&index=0&id=11d94b78&module=divider&lang=css"
cssModules["divider"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__